import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {assert} from 'Asserts';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineGraphQL, PipelineStep} from 'pipelines/PipelineTypes';

/**
 * @deprecated  Use `getStepFromAnalysis` instead
 */
export default function getLegacyStepFromAnalysis(
  pipeline: PipelineGraphQL,
  stepId: string
): GetAnalysisPipelineStep {
  const step = getLegacyNullableStepFromAnalysis(pipeline, stepId);
  assert(step != null, 'Could not find step', {stepId});
  return step;
}

/**
 * @deprecated Use `getNullableStepFromAnalysis` instead
 */
export function getLegacyNullableStepFromAnalysis(
  pipeline: PipelineGraphQL,
  stepId: string
): GetAnalysisPipelineStep | null {
  return pipeline.execution.steps.find((step) => step.id === stepId) ?? null;
}

export function getStepFromAnalysis<
  StepType extends PipelineStepType = PipelineStepType,
  StepVersion extends number = number,
>(pipeline: PipelineGraphQL, stepId: string): PipelineStep<StepType, StepVersion> {
  const step = getNullableStepFromAnalysis<StepType, StepVersion>(pipeline, stepId);
  assert(step != null, 'Could not find step', {stepId});
  return step;
}

export function getNullableStepFromAnalysis<
  StepType extends PipelineStepType = PipelineStepType,
  StepVersion extends number = number,
>(pipeline: PipelineGraphQL, stepId: string): PipelineStep<StepType, StepVersion> | null {
  return (pipeline.steps.find((step) => step.id === stepId) as PipelineStep<StepType, StepVersion>) ?? null;
}

export function pipelineHasStep(pipeline: PipelineGraphQL, stepId: string): boolean {
  return getLegacyNullableStepFromAnalysis(pipeline, stepId) != null;
}
